module.exports = __webpack_public_path__ + "img/nav-filter-icon.11220e69.svg";